// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__yIdKH","title":"FrontImage_title__3WlZi"};